(ns minorodata.connections.sources.discord
  (:require [minorodata.app.utils :as app.utils]
            [clojure.string :as c.string]
            [cljs.spec.alpha :as spec]
            [spec-tools.core :as st]
            [mold-forms.core :as form-component]))


(spec/def ::name
  (spec/and (st/spec string? {:reason "Please provide a name for the source"})
            (st/spec (complement c.string/blank?) {:reason "Name can't be empty"})))


(spec/def ::description
  (spec/nilable string?))


(spec/def ::auth-credentials-id
  (spec/and (st/spec string? {:reason "Please provide a valid auth token"})
            (st/spec (complement c.string/blank?) {:reason "Please provide a valid auth token"})))


(spec/def ::auth-credentials
  (spec/keys :req-un [::auth-credentials-id]))


(spec/def ::discord-form
  (spec/keys :req-un [::name ::auth-credentials]
             :opt-un [::description]))


(def source
  {:id                "discord-oauth"
   :enabled           true
   :name              "Discord"
   :description       "VoIP, instant messaging and digital distribution platform designed for creating communities"
   :image-source      "discord.png"
   :tags              ["marketing"]

   :preview-formatter (fn [source]
                          (if (:is-token-valid source)
                            (str "Authenticated by token")
                            [:span {:class "text-kleene-error-01"
                                    :title         "TOKEN EXPIRED"}
                             "AUTH TOKEN EXPIRED"]))

   :form              {:format-for-api
                       (fn format-for-api [{:keys [auth-credentials name description]}]
                           {:source-type "discord-oauth"
                            :name        name
                            :description description
                            :source      {:auth-credentials-id (:auth-credentials-id auth-credentials)
                                          :is-token-valid      (:is-token-valid auth-credentials)
                                          :has-third-leg       true}})

                       :format-for-inputs
                       (fn format-for-inputs [{:keys [source name description]}]
                           (let [{:keys [auth-credentials-id is-token-valid tenants]} source]
                                {:name                name
                                 :description         description
                                 :auth-credentials    (when (and (some? auth-credentials-id)
                                                                 (some? is-token-valid))
                                                            {:auth-credentials-id auth-credentials-id
                                                             :is-token-valid      is-token-valid})
                                 :auth-credentials-id auth-credentials-id

                                 :is-token-valid      is-token-valid}))

                       ;; TODO:
                       ;; Replace :format-for-api and :format-for-fields with a single :mapping, like so
                       ;; {:block-type :input
                       ;;  :name       :some-name
                       ;;  :mapping    [:credentials :some_name]}
                       ;; Also, think of having `:input-type :hidden` blocks as placeholders
                       ;; for static fields in the final configuration.

                       :validate
                       (partial form-component/validate-form ::discord-form)

                       :id
                       :discord-oauth-form

                       :blocks
                       [{:block-type :input
                         :label      "Source name"
                         :required   true
                         :name       :name
                         :value      ""}

                        {:block-type :input
                         :label      "Description"
                         :name       :description
                         :value      ""}

                        {:block-type           :oauth
                         :label                "Discord Login"
                         :name                 :auth-credentials
                         :required             true

                         :request-uri          "https://discord.com/api/oauth2/authorize"
                         :params-processor     (fn [{:keys [client-id redirect-uri state scope response-type permission]}]
                                                   {:response_type response-type
                                                    :scope         scope
                                                    :client_id     client-id
                                                    :redirect_uri  redirect-uri
                                                    :state         state
                                                    :permissions    permission})

                         :response-processor   (fn [data]
                                                   (select-keys data [:auth-credentials-id :is-token-valid]))

                         :oauth-connector-type "discord"
                         :has-third-leg        true

                         :response-type        "code"
                         :client-id            "857566693857689610"
                         :scope                "messages.read guilds bot identity email"
                         ;;bot permission
                         :permission        8}

                        {:block-type :submit
                         :content    "SAVE"}]}

   :extract-form      {:format-for-api
                       (fn format-for-api [{:keys [name description status action destination-table
                                                   report extract-type guild-id]}]
                           {:name          name
                            :description   description
                            :status        status
                            :output-tables [destination-table]
                            :config        {:extracts [{:action            action
                                                        :report            report
                                                        :destination-table destination-table
                                                        :extract-type      extract-type
                                                        :guild-id          guild-id}]}})

                       :format-for-inputs
                       (fn format-for-inputs [{:extract/keys [name description status config source-id]}]
                           (let [extract (get-in config [:extracts 0])]
                                (merge
                                  (select-keys extract [:report :action :destination-table :extract-type :guild-id])
                                  (app.utils/keep-non-nil-keys
                                    {:name          name
                                     :description   description
                                     :status        status
                                     :output-tables []
                                     :source-id     source-id}))))

                       :validate
                       (constantly nil)

                       :id
                       :discord-extract-form

                       :blocks
                       [{:block-type :input
                         :label      "Extract name"
                         :required   true
                         :name       :name
                         :value      ""}

                        {:block-type :input
                         :label      "Description"
                         :name       :description
                         :value      ""}

                        {:block-type :select
                         :label      "Status"
                         :name       :status
                         :options    [{:name "Active" :value "active"}
                                      {:name "Paused" :value "paused"}]
                         :required   true
                         :value      "active"}

                        {:block-type :subtitle
                         :content    "Extract Configuration"}

                        {:block-type :form-value
                         :name       :source-id}


                        {:block-type :select
                         :label      "Report"
                         :name       :report
                         :options    [{:name "Members" :value "members"}
                                      {:name "Guilds"  :value "guilds"}
                                      {:name "Channels" :value "channels"}
                                      {:name "Messages" :value "messages"}]
                         :disabled   false
                         :required   true
                         :value      "members"}

                        {:block-type :input
                         :label      "Guild ID"
                         :name       :guild-id
                         :conditions [[:eq [:report :value]  "members"]
                                      [:eq [:report :value]  "guilds"]
                                      [:eq [:report :value]  "channels"]
                                      [:eq [:report :value]  "messages"]]}

                        {:block-type :subtitle
                         :content    "Data loading options"}

                        {:block-type :select
                         :label      "Load method"
                         :name       :action
                         :options    [{:name "Drop, Create, Load" :value "replace"}
                                      {:name "Truncate, Load"     :value "reload"}
                                      {:name "Append"             :value "append"}]
                         :required   true
                         :value      "replace"}

                        {:content "Drop table, Create table, load entire table (selected columns)"
                         :conditions [[:eq [:action :value] "replace"]]}

                        {:content "Truncate table, Load entire table (selected columns)"
                         :conditions [[:eq [:action :value] "reload"]]}

                        {:content "Load entire table (selected columns) into the destination table no table recreation, no truncation"
                         :conditions [[:and [[:action :value] [:extract-type :value]] ["append" "full-load"]]]}

                        {:content "Find max record in destination table of specified incremental key. Select rows where results of incremental key greater than max record of incremental key in destination table. Insert rows (selected columns) into the destination table no truncation."
                         :conditions [[:and [[:action :value] [:extract-type :value]] ["append" "incremental"]]]}

                        {:block-type :subtitle
                         :content    "Destination table"}

                        {:block-type  :warehouse-destination
                         :name        :destination-table}

                        {:block-type :submit
                         :content    "SAVE"}]}})
